<template>
    <div>
        <div>
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">OA审批-代岗申请</div>
            <el-button
                style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                @click="Return">返回</el-button>

            <!-- 主体 -->
            <div style="height:680px;background-color:white;margin:75px 40px 0 40px;padding:40px 60px;overflow-x: hidden">
                <!-- 查询框 -->
                <span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
                <span style="font-size:20px;font-weight:700">代岗信息</span>
                <div style="border:1px solid #DADADA;margin-top:10px"></div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-row style="margin-top:40px">
                        <el-col :span="12">
                            <el-form-item label="组织架构:" prop="name">
                                {{ editData.organize_name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="城市:" prop="name">
                                {{ editData.city_id }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="代岗人:" prop="name">
                                {{ editData.post_name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="代岗原因:" prop="name">
                                {{ editData.replace_staff_name }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="代岗原因:" prop="name">
                                {{ editData.replace_reason }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="代岗开始时间:" prop="name">
                                {{ editData.start_date }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="代岗结束时间:" prop="name">
                                {{ editData.end_date }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="天数:" prop="name">
                                {{ editData.replace_days }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="元/天:" prop="name">
                                {{ editData.day_price }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="总金额:" prop="name">
                                {{ editData.total_amount }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div style="margin-top:20px;">
                        <span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
                        <span style="font-size:20px;font-weight:700">备注信息</span>
                        <div style="border:1px solid #DADADA;margin-top:10px"></div>
                        <el-row style="margin-top:40px">
                            <el-col :span="12">
                                <el-form-item label="备注:" prop="name">
                                    <el-input placeholder="请输入备注内容" style="width: 50%; margin-left: 10px;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                            </el-col>
                        </el-row>

                        <el-row v-show="reviewer_state == 0">
                            <el-col style="margin:50px 500px;">
                                <el-button type="goon" @click="$refs['examine'].save(id, 1)">同意</el-button>
                                <el-button type="addbtn" @click="$refs['examine'].reject(id)">驳回</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>

            </div>

        </div>
        <examine ref="examine"></examine>
    </div>
</template>

<script>
import examine from "./OA_examine.vue";
export default {
    components: {
        examine: examine,
    },
    props: ["editData", "id", "reviewer_state"],
    data() {
        return {};
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        Return() {
            this.$parent.Return();
        }
    }
}
</script>

<style>
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    content: '';
}
</style>



// WEBPACK FOOTER //
// QAsp_dgsq.vue?595ed610